import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftSetUp } from '../ShiftSetUp/ShiftSetUp';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'SectionList',
    templateUrl: './SectionList.html',
})

export class SectionList extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    DeptId: number;
    PropertyID: number;  
    SectionList: Array<any>;
    AllSectionSelected: boolean;
    StaffName: number;
    SectionCount: number;
    DisableModalOpenEvent: boolean = false;

    @Output() SectionUpdate: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);        
    }
    ngOnInit(): void {
        this.PropertyID = this.masterService.ActivePropertyID;        
    }

    Open(Sections, StaffName): void {
        if (this.DisableModalOpenEvent) return;
        this.SectionCount = 0;
        this.StaffName = StaffName;
        this.SectionList = this.shiftSetUp.sectionList;
        this.SectionList = this.SectionList.map((row) => {
            if (Sections.indexOf(row.Id) != -1) {
                row.Selected = true;
                this.SectionCount++;
            }
            else
                row.Selected = false;
            return row;
        })
        if (this.SectionCount == this.SectionList.length)
            this.AllSectionSelected = true;
        else
            this.AllSectionSelected = false;
        let ngbModalOptions: NgbModalOptions = {
                backdrop : 'static',
                centered: true
            };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    AddSection(event: any, index): void {
        if (event.target.checked) {
            this.SectionList[index].Selected = true;
            this.SectionCount++;
        }
        else {
            this.SectionList[index].Selected = false;
            this.SectionCount--;
        }
        if (this.SectionCount == this.SectionList.length)
            this.AllSectionSelected = true;
        else
            this.AllSectionSelected = false;
    }

    SelectAll(event: boolean): void{
        if (event) {
            for (var i = 0; i < this.SectionList.length; i++) {
                this.SectionList[i].Selected = true;
            }
            this.SectionCount = this.SectionList.length;
        }
        else {
            for (var i = 0; i < this.SectionList.length; i++) {
                this.SectionList[i].Selected = false;
            }
            this.SectionCount = 0;
        }
    }

    SaveSection() {
        let SectionIds = [];
        for (let i = 0; i < this.SectionList.length; i++) {
            if (this.SectionList[i].Selected)
                SectionIds.push(this.SectionList[i].Id)
        }       
        this.SectionUpdate.emit(SectionIds);
        this.ModalRef.close();
    }
    //onKeyword(value: string): void {
    //    this.SectionList = this.shiftSetUp.sectionList.filter((row) => {
    //        if (value == null || value.trim() == "") {
    //            return true;
    //        }
    //        let data = row.Name.toUpperCase();
    //        value = value.toLocaleUpperCase();
    //        return (data.indexOf(value) >= 0);
    //    })
    //}
}
